module.exports = __webpack_public_path__ + "static/media/manorHomeAboutImg.86efe8ec.png";